import { PopupFieldData, RadioChoice } from "src/app/features/designer-studio/edit-pdf-doc/models/doc.model";

export enum ComponentType {
  Label = 'label',
  Button = 'button',
  Line = 'hr',
  ComboBox = 'select',
  Radio = 'radio',
  Image = 'image',
  Anchor = 'anchor',
  Input = 'text',
  Checkbox = 'checkbox'
}

export enum PopupAppFieldType {
  TEXT = 'TEXT',
  LABEL = 'NONE',
  BUTTON = 'PUSHBTN',
  SELECT = 'COMOBOX',
  RADIO = 'RADIOBTN',
  IMAGE = 'IMAGE',
  ANCHOR = 'NONE',
  INPUT = 'TEXT',
  CHECKBOX = 'CHECKBOX',
  HR = 'NONE'
}

export type StageComponent = Record<ComponentType, ComponentBaseOptions>;

export type ComponentBaseOptions  = {
  inner_text: string;
  width: number;
  height: any;
  fontFamily?: string;
  fontSize?: string; 
  fontWeight?: string;
  hidden?: boolean;
  icon?: string; 
  style?: string;
  textAlign?: string;
  type: ComponentType;
  url?: string;
  src?: string;
  choices?: RadioChoice[];
  borderStyle?: string;
  options?: string[];
  size?: number;
};

export type ComponentOptions  = PopupFieldData & {
  stageRef: HTMLElement | null;
  parentRect: ComponentRect | null;
};

export type ComponentRect = {
  bottom: number;
  height: number;
  left: number;
  right: number;
  top: number;
  width: number;
  offsetLeft: number;
  offsetTop: number;
  x: number;
  y: number;
  maxX?: number;
  maxY?: number;
};

export type Vector = {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
};
